import React from 'react'
// @src imports
import { UiCard } from 'src/chrome'
import { FlexColumn } from 'src/styled'
import {
  useState,
  useSubscriptions,
  useUserLabels,
  useVertical,
} from 'src/hooks'
import {
  Anchor,
  Button,
  ButtonType,
  Spacer,
  Text,
} from '@sendoutcards/quantum-design-ui'
import { perform } from 'src/app/api'
import {
  GetPromptingsAcademyLoginUrl,
  GetPromptingsAcademyLoginUrlData,
} from 'src/legacy_graphql'

const twoFields: React.CSSProperties = {
  display: 'flex',
  width: '100%',
  margin: 'auto',
  alignItems: 'center',
  flexDirection: 'row',
  flexWrap: 'wrap',
}
interface StreamLinksCardProps {
  isAffiliate: boolean
  isSRP: boolean
}

const websiteLinks = [
  {
    title: 'www.promptings.com',
    href: 'https://www.promptings.com/',
  },
  {
    title: 'www.promptingsacademy.com',
    href: 'https://www.promptingsacademy.com/',
  },
  {
    title: 'www.blue42forlife.com',
    href: 'https://www.blue42forlife.com/',
  },
  {
    title: 'www.bellacadeaux.com',
    href: 'https://www.bellacadeaux.com/',
  },

  {
    title: 'www.streamvirtualassistant.com',
    href: 'https://www.streamvirtualassistant.com/',
  },
  {
    title: 'www.sendoutcards.com',
    href: 'https://www.sendoutcards.com/',
  },
]

const subscriptionLinks = [
  {
    title: 'SendOutCards',
    domainName: 'SendOutCards',
    brand: 'soc',
    type: 'secondary',
  },
  {
    title: 'Promptings Way Courses',
    domainName: 'PromptingsAcademy',
    brand: 'promptingsAcademy',
    type: 'secondary',
  },
  {
    title: 'Stream Virtual Assistant',
    domainName: 'streamvirtualassistant',
    brand: 'streamVA',
    type: 'secondary',
  },
]

const StreamLinksCard: React.FC<StreamLinksCardProps> = props => {
  const { hasStreamVASubscription, hasSocSubscription } = useSubscriptions()
  const userLabels = useUserLabels()

  const vertical = useVertical()

  const [isRedirecting, setIsRedirecting] = useState(false)

  const linkDestination = async (domainName: string) => {
    switch (domainName) {
      case 'PromptingsAcademy':
        const result = await perform<GetPromptingsAcademyLoginUrlData>(
          GetPromptingsAcademyLoginUrl(),
        )
        return (
          result.account.promptinguLoginUrl ?? 'https://promptingsacademy.com'
        )
      default:
        return `https://www.${domainName}.com/`
    }
  }

  const streamButtons = subscriptionLinks.map(link => {
    if (vertical.brand === link.brand) {
      return <></>
    }
    // tslint:disable-next-line
    return (
      <>
        <Spacer space="x2" orientation="horizontal" />
        <Button
          title={link.title}
          size="small"
          onClick={async () => {
            setIsRedirecting(true)
            const url = await linkDestination(link.domainName)
            window.open(url, '_blank')
            setIsRedirecting(false)
          }}
          disabled={
            (link.domainName === 'SendOutCards' && !hasSocSubscription) ||
            (link.domainName === 'PromptingsAcademy' &&
              !userLabels.hasRelationshipMarketing) ||
            (link.domainName === 'streamvirtualassistant' &&
              !hasStreamVASubscription) ||
            isRedirecting
          }
          disabledCaption={
            isRedirecting
              ? 'redirecting...'
              : 'You must be a paid subscriber to use this Stream.'
          }
          type={link.type as ButtonType}
        />
      </>
    )
  })
  return (
    <UiCard style={{ width: '100%' }} title={'Stream Links'}>
      <FlexColumn
        style={{
          width: '100%',
        }}
      >
        <Spacer space="x1" />
        <div style={twoFields}>
          <Text type="body" color="primaryHeading" outset={{ top: 'x1' }}>
            Website Links:
          </Text>
          {websiteLinks.map(link => {
            return (
              <>
                <Spacer space="x2" orientation="horizontal" />
                <Anchor
                  target="_blank"
                  href={link.href}
                  title={link.title}
                  color="anchorBlue"
                  isDecorated={true}
                />
              </>
            )
          })}
        </div>
        <div style={twoFields}>
          <Text type="body" color="primaryHeading" outset={{ top: 'x1' }}>
            Subscription Links:
          </Text>
          {streamButtons}
        </div>
      </FlexColumn>
    </UiCard>
  )
}

export default StreamLinksCard
